import logger from "@basic/log";

export default new logger("app-web-tracking", "mlszp-visitor-h5");
